import { render, staticRenderFns } from "./home.vue?vue&type=template&id=7970837d&scoped=true"
import script from "./home.vue?vue&type=script&lang=ts&setup=true"
export * from "./home.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./home.vue?vue&type=style&index=0&id=7970837d&prod&scoped=true&lang=css"
import style1 from "./home.vue?vue&type=style&index=1&id=7970837d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7970837d",
  null
  
)

export default component.exports